/* eslint-disable */
import React from 'react'
import {message} from 'antd'
import http from '../../Component/Interceptor/Interseptor'
import {Link} from 'react-router-dom'
import cookie from 'react-cookies'
import CRM from '../BaseComponent/CRM'

class AddDefinition extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      error: '',
      subjectList: [],
      categoryList: []
    }
  }
  componentDidMount() {
    http.get(`${CRM.CRM_CONTACT_CATEGORY_LIST}`, {}).then((response) => {
      // alert(JSON.stringify(response.data))
      if (response.data.error == null) {
        this.setState({
          categoryList: response.data.object
        })
      } else {
        this.setState({
          categoryList: []
        })
      }
    })
  }

  changeCategory = (e) => {
    let value = e.target.value
    if (value === '') {
      this.setState({
        subjectList: []
      })
    } else {
      http.get(`${CRM.CRM_CONTACT_SUBJECT_LIST}?contactCategoryId=${value}`, {}).then((response) => {
        if (response.data.error == null) {
          this.setState({
            subjectList: response.data.object
          })
        } else {
          this.setState({
            subjectList: []
          })
        }
      })
    }
  }

  addDefinition() {
    var name = document.getElementById('name').value
    var contactSubjectId = document.getElementById('contactSubjectId').value
    var enabled = document.getElementById('enabled').value
    var nameError = false
    var enableError = false
    var formError = false
    var subError = false

    if (contactSubjectId == '') {
      formError = true
      subError = true
      message.error('موضوع تماس وارد شود')
    } else {
      if (!subError) {
        this.setState({
          error: ''
        })
      }
    }

    if (name == '') {
      formError = true
      nameError = true
      message.error('عنوان جزییات تماس وارد شود')
    } else {
      if (!nameError) {
        this.setState({
          error: ''
        })
      }
    }

    if (enabled == '') {
      formError = true
      enableError = true
      message.error('وضعیت را مشخص کنید')
    } else {
      if (!enableError) {
        this.setState({
          error: ''
        })
      }
    }
    if (!formError) {
      let data = {
        name,
        enabled,
        contactSubjectId
      }

      http
        .post(`${CRM.CRM_CONTACT_DEFINITION_ADD}`, data)
        .then((response) => {
          if (response.data.error == null) {
            message.success('جزییات تماس جدید اضافه شد')
            setInterval(() => {
              window.location.assign('/reportDefinition')
            }, 2000)
          } else {
            message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
          }
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    }
  }

  submit(e) {
    e.preventDefault()
  }
  render() {
    return (
      <div className={'rtl'}>
        {/*<AdminMenu/>*/}
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>اطلاعات پایه</li>
            <li>ارتباط با مشتری</li>
            <li>
              <Link to={'/reportDefinition'}>جزییات تماس</Link>
            </li>
            <li>افزودن جزییات تماس</li>
          </ul>
          <form className="verticalForm" onSubmit={this.submit.bind(this)}>
            <div className="headerVertical">
              <p>ثبت جزییات تماس</p>
            </div>

            <div className="formComponent">
              <label>
                خانواده تماس : <span className="requireFiled">*</span>
              </label>
              <select className="form-control" id="category" onChange={this.changeCategory.bind(this)}>
                <option value="">------</option>
                {this.state.categoryList.map((category, index) => (
                  <option value={category.contactCategoryId}>{category.contactCategoryName}</option>
                ))}
              </select>
            </div>

            <div className="formComponent">
              <label>
                موضوع تماس <span className="requireFiled">*</span>
              </label>
              <select className="form-control" id="contactSubjectId">
                <option value="">------</option>
                {this.state.subjectList.map((category, index) => (
                  <option value={category.contactSubjectId}>{category.contactSubjectName}</option>
                ))}
              </select>

              <label>
                عنوان <span className="requireFiled">*</span>
              </label>
              <input type="text" id="name" className="form-control" />

              <label>
                وضعیت <span className="requireFiled">*</span>
              </label>
              <select className="form-control" name="enabled" id="enabled">
                <option value="">------</option>
                <option value={1}>فعال</option>
                <option value={0}>غیر فعال</option>
              </select>

              <button className="btn btn-info btn-block" onClick={this.addDefinition.bind(this)}>
                ثبت جزییات تماس جدید
              </button>
            </div>
          </form>
        </div>
      </div>
    )
  }
}

export default AddDefinition
